export const getRequestId = function (): string | undefined {
  const match = document.cookie.match('(^|; )request_id=([^;]*)');
  const requestId = match && match[2];
  if (requestId) {
    return decodeURIComponent(requestId);
  }
};
